import {Component, OnInit} from '@angular/core';
import {UploadService} from '../../services/upload.service';

@Component({
  selector: 'app-call-api',
  templateUrl: './call-api.component.html',
  styleUrls: ['../../app.component.scss', './call-api.component.scss']
})
export class CallApiComponent implements OnInit {
  createVideo = false;

  constructor(public uploadService: UploadService) {
  }

  ngOnInit(): void {
  }

  onSelectionChange(uploadWay): void {
    this.createVideo = uploadWay === 'createVideo';
  }
}
